export const styles = {
  global: {},
};
